import React, { useState, useEffect } from "react";
import { Form, Col, Row, Button, Modal } from "react-bootstrap";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import "../styles/Record.css";
import { toast } from "react-toastify";
import axiosInstance from "../axiosInstance";

export default function Record() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [startDate, setStartDate] = useState(new Date());
  const [reference_number, setReference] = useState([]);
  const [issue_voucher, setIssueVoucher] = useState("");
  const [name, setName] = useState("");
  const [sex, setSex] = useState("Male");
  const [age, setAge] = useState("1 - Adult");
  const [health_condition, setHealthCondition] = useState(
    "1 - Severly Compromised and Thin"
  );
  const [weight, setWeight] = useState(0);
  const [parasites, setParasites] = useState("No");
  const [receiving_details, setRecevingDetails] = useState("");
  const [marks, setMarks] = useState("");
  const [area, setArea] = useState("");
  const [captivity_time, setCaptivityTime] = useState("");
  const [mode_of_transport, setModeTransport] = useState("");
  const [authoritative_contact, setAuthoritativeContact] = useState("");
  const [criminal_case, setCriminalCase] = useState(false);

  const [showSave, setShowSave] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleCloseSave = () => setShowSave(false);
  const handleCloseSuccess = () => setShowSuccess(false);
  const handleSave = () => {
    submit();
    setShowSave(false);
  };
  function handleShowSave(e) {
    e.preventDefault();
    setShowSave(true);
  }

  async function submit() {
    var items = {};
    var api = "";
    if (!id) {
      api = "/api/add-record";
      items = {
        date: startDate,
        reference_number,
        issue_voucher,
        name,
        sex,
        age,
        health_condition,
        weight,
        parasites,
        receiving_details,
        marks,
        area,
        captivity_time,
        mode_of_transport,
        authoritative_contact,
        criminal_case,
      };
    } else {
      api = "/api/update-record";
      items = {
        id,
        date: startDate,
        reference_number,
        issue_voucher,
        name,
        sex,
        age,
        health_condition,
        weight,
        parasites,
        receiving_details,
        marks,
        area,
        captivity_time,
        mode_of_transport,
        authoritative_contact,
        criminal_case,
      };
    }
    var result = await axiosInstance.post(api, items);
    if (result.data.code !== "ER_PARSE_ERROR") {
      toast.success(result.data, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
      setStartDate(new Date());
      setReference([]);
      setIssueVoucher("");
      setName("");
      setSex("Male");
      setAge("1 - Adult");
      setHealthCondition("1 - Severly Compromised and Thin");
      setWeight(0);
      setParasites("No");
      setRecevingDetails("");
      setMarks("");
      setArea("");
      setCaptivityTime("");
      setModeTransport("");
      setAuthoritativeContact("");
      setCriminalCase(false);
      setShowSuccess(true);
      if (id) {
        navigate("/view-record");
      }
    } else {
      toast.error(result.data.sqlMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
    }
  }

  async function getData() {
    const result = await axiosInstance.post("/api/get-record", { id });
    const record = result.data[0];
    setStartDate(new Date(record.date));
    setReference(record.reference_number);
    setIssueVoucher(record.issue_voucher);
    setName(record.name);
    setSex(record.sex);
    setAge(record.age);
    setHealthCondition(record.health_condition);
    setWeight(record.weight);
    setParasites(record.parasites);
    setRecevingDetails(record.receiving_details);
    setMarks(record.marks);
    setArea(record.area);
    setCaptivityTime(record.captivity_time);
    setModeTransport(record.mode_of_transport);
    setAuthoritativeContact(record.authoritative_contact);
    setCriminalCase(record.criminal_case === 1);
  }

  useEffect(() => {
    if (id > 0) {
      getData();
    }
  }, []);

  const toggleCriminalCase = () => {
    const temp = !criminal_case;
    setCriminalCase(temp);
  };

  return (
    <div className="record">
      <div className="formGroup">
        <h2 className="heading">Add New Record</h2>
        <Form.Group as={Col} controlId="formGroupDate">
          <Form.Check
            className="switch"
            type="switch"
            id="criminal-switch"
            label="Criminal Case"
            checked={criminal_case}
            onChange={toggleCriminalCase}
          />
          <DatePicker
            className="datepicker"
            selected={startDate}
            onChange={(e) => setStartDate(e)}
            showTimeSelect
            timeIntervals={1}
            dateFormat="dd/MM/yyyy HH:mm"
          />
        </Form.Group>
        <Form>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupReference">
                <Form.Label>Reference Number</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Reference Number"
                  value={reference_number}
                  onChange={(e) => setReference(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupIssueVoucher">
                <Form.Label>
                  Official Document Reference (Issue Voucher)
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Official Document Reference (Issue Voucher)"
                  value={issue_voucher}
                  onChange={(e) => setIssueVoucher(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupName">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupSex">
                <Form.Label>Sex</Form.Label>
                <Form.Control
                  as="select"
                  defaultValue={sex}
                  onChange={(e) => setSex(e.target.value)}
                >
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupAge">
                <Form.Label>Approx. Age</Form.Label>
                <Form.Control
                  as="select"
                  defaultValue={age}
                  onChange={(e) => setAge(e.target.value)}
                >
                  <option value="1 - Adult">1 - Adult</option>
                  <option value="2 - Young Adult (Under 5 kgs)">
                    2 - Young Adult (Under 5 kgs)
                  </option>
                  <option value="3 - Juvenile (Weaned)">
                    3 - Juvenile (Weaned)
                  </option>
                  <option value="4 - Milk Dependent Juvenile">
                    4 - Milk Dependent Juvenile
                  </option>
                  <option value="5 - Neonate">5 - Neonate</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupHealth">
                <Form.Label>Health Condition</Form.Label>
                <Form.Control
                  as="select"
                  defaultValue={health_condition}
                  onChange={(e) => setHealthCondition(e.target.value)}
                >
                  <option value="1 - Severly Compromised and Thin">
                    1 - Severly Compromised and Thin
                  </option>
                  <option value="2 - Thin But Able to Walk">
                    2 - Thin But Able to Walk
                  </option>
                  <option value="3 - Average Condition">
                    3 - Average Condition
                  </option>
                  <option value="4 - Good Condition">4 - Good Condition</option>
                  <option value="5 - Excellent Condition">
                    5 - Excellent Condition
                  </option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupWeight">
                <Form.Label>Weight</Form.Label>
                <Row>
                  <Col xs={10}>
                    <Form.Control
                      type="text"
                      placeholder="Weight"
                      value={weight}
                      onChange={(e) => {
                        const regex = new RegExp(
                          "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                        );
                        if (regex.test(e.target.value)) {
                          const s = e.target.value.replace(
                            /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                            ""
                          );
                          setWeight(s);
                        } else if (e.target.value === "") {
                          setWeight(0);
                        }
                      }}
                    />
                  </Col>
                  <Col className="labelcol">
                    <Form.Label className="label">kgs</Form.Label>
                  </Col>
                </Row>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupParasites">
                <Form.Label>Parasites Present</Form.Label>
                <Form.Check
                  type="radio"
                  id="parasite-radio-yes"
                  label="Yes"
                  name="parasiteRadios"
                  value="Yes"
                  checked={parasites === "Yes"}
                  onChange={(e) => setParasites(e.target.value)}
                />
                <Form.Check
                  type="radio"
                  id="parasite-radio-no"
                  label="No"
                  name="parasiteRadios"
                  value="No"
                  checked={parasites === "No"}
                  onChange={(e) => setParasites(e.target.value)}
                />
                <Form.Check
                  type="radio"
                  id="parasite-radio-unknown"
                  label="Unknown"
                  name="parasiteRadios"
                  value="Unknown"
                  checked={parasites === "Unknown"}
                  onChange={(e) => setParasites(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Label>
                  Details of Receiving and Any Other Circumstances to Note
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Details of Receiving and Any Other Circumstances to Note"
                  value={receiving_details}
                  onChange={(e) => setRecevingDetails(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupMarks">
                <Form.Label>Distinguished Marks or Disfigurations</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Distinguished Marks or Disfigurations"
                  value={marks}
                  onChange={(e) => setMarks(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupArea">
                <Form.Label>Area Originally From (If Known)</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Area Originally From (If Known)"
                  value={area}
                  onChange={(e) => setArea(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupTime">
                <Form.Label>Time in Captivity (If Known)</Form.Label>
                <Row>
                  <Col xs={10}>
                    <Form.Control
                      type="text"
                      placeholder="Time in Captivity (If Known)"
                      value={captivity_time}
                      onChange={(e) => setCaptivityTime(e.target.value)}
                    />
                  </Col>
                  <Col className="labelcol">
                    <Form.Label className="label">days</Form.Label>
                  </Col>
                </Row>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupTransport">
                <Form.Label>Mode of Transport (If Known)</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Mode of Transport (If Known)"
                  value={mode_of_transport}
                  onChange={(e) => setModeTransport(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group as={Col} controlId="formGroupContact">
                <Form.Label>Authoritative Point of Contact</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Authoritative Point of Contact"
                  value={authoritative_contact}
                  onChange={(e) => setAuthoritativeContact(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                className="submit-button"
                type="submit"
                onClick={(e) => {
                  handleShowSave(e);
                }}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
      <div>
        <Modal show={showSave} onHide={handleCloseSave}>
          <Modal.Header closeButton>
            <Modal.Title>Save</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>Are you sure you want to save this device.</p>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSave}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Save changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div>
        <Modal show={showSuccess} onHide={handleCloseSuccess}>
          <Modal.Header closeButton>
            <Modal.Title>Success</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Successfuly Submited.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSuccess}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}
